import type { ReactNode } from 'react'
import { ArrowDownRight, ArrowUpRight, Minus, MoreHorizontal } from 'lucide-react'
import { cls } from '../lib/utils'
import type { MetricCard as MetricCardType } from '../types'

export function MetricCard({ metric }: { metric: MetricCardType }) {
  const TrendIcon = metric.trend === 'up' ? ArrowUpRight : metric.trend === 'down' ? ArrowDownRight : Minus
  return <div className={cls('metric-card', metric.tone && `tone-${metric.tone}`)}><div className="metric-head"><span>{metric.label}</span><MoreHorizontal size={18}/></div><div className="metric-value">{metric.value}</div><div className="metric-foot"><span>{metric.hint}</span>{metric.trendLabel && <b><TrendIcon size={14}/>{metric.trendLabel}</b>}</div></div>
}

export function Section({ title, subtitle, action, children, className }: { title: string, subtitle?: string, action?: ReactNode, children: ReactNode, className?: string }) {
  return <section className={cls('panel', className)}><div className="panel-head"><div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>{action}</div>{children}</section>
}

export function Badge({ children, tone='neutral' }: { children: ReactNode, tone?: 'good'|'warn'|'bad'|'neutral'|'blue' }) {
  return <span className={cls('badge', `badge-${tone}`)}>{children}</span>
}

export function Progress({ value, label }: { value: number, label?: string }) {
  return <div className="progress-wrap">{label && <div className="progress-label"><span>{label}</span><b>{value}%</b></div>}<div className="progress"><span style={{width:`${Math.min(100,value)}%`}}/></div></div>
}
export function WorkspaceSkeleton({ rows = 3 }: { rows?: number }) {
  return <div className="workspace-skeleton" aria-label="Loading">
    <div className="skeleton skeleton-title"/>
    <div className="skeleton skeleton-subtitle"/>
    <div className="skeleton-card-grid">
      {Array.from({ length: rows }).map((_, index) => <div className="skeleton-card" key={index}>
        <div className="skeleton skeleton-line short"/>
        <div className="skeleton skeleton-value"/>
        <div className="skeleton skeleton-line"/>
        <div className="skeleton skeleton-line medium"/>
      </div>)}
    </div>
    <div className="skeleton skeleton-panel"/>
  </div>
}

